var _circle, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPosLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.1113,
    cy: 36,
    r: 35,
    fill: "#880A78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 23.0467C38.9697 20.9218 44.9042 23.6669 46.4315 25.4377C41.7183 32.4503 33.559 33.8487 30.0685 33.6714C27.9956 33.5828 23.7188 32.5027 23.1952 28.8903C22.6715 25.2779 25.8133 23.5778 27.4497 23.0467Z",
    fill: "url(#paint0_linear_2621_1411)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.414 26.4997C39.5594 41.7993 26.6867 39.0723 21.2322 35.7963C16.9776 50.1396 19.5958 50.9365 22.5413 53.0614C24.8976 54.7613 25.4867 53.7697 25.4867 53.0614L27.4497 45.0929C27.4497 44.296 28.3007 42.7555 31.7049 42.968C35.1091 43.1805 40.1051 41.6399 42.1776 40.843C51.3413 36.1682 49.4867 29.333 47.414 26.4997Z",
    fill: "url(#paint1_linear_2621_1411)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3819 20.302L51.0728 18L49.9819 20.302H47.1455L49.1091 22.0728L48.6728 24.3748L51.0728 23.1353L53.4728 24.1977L53.2546 21.8957L55.0001 20.302H52.3819Z",
    fill: "url(#paint2_linear_2621_1411)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2621_1411",
    x1: 53.0297,
    y1: 22.2742,
    x2: 53.0297,
    y2: 131.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2621_1411",
    x1: 53.0297,
    y1: 22.2742,
    x2: 53.0297,
    y2: 131.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2621_1411",
    x1: 55.3273,
    y1: 18,
    x2: 55.3273,
    y2: 39.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosLogo);
export default __webpack_public_path__ + "static/media/posLogo.1aec052dc85b6337244e38a32881407f.svg";
export { ForwardRef as ReactComponent };